<template>
  <div :class="['loader-component', loaderSize, loaderColor]">
    <img v-if="custom" :src="`assets/images/custom-loaders/${custom}.svg`">
    <div v-else class="watersplash">
      <div>
        <span />
        <span />
        <span />        
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import LoaderMixin from './LoaderMixin'
import './Loader.scss'

@Component({
  mixins: [
    LoaderMixin,
  ],
  props: {
    color: {
      type: String,
      required: false,
      default: 'white',
    },
    size: {
      type: String,
      required: false,
      default: 'big',
    },
    custom: {
      type: String,
      required: false,
    },
  },
})
export default class Loader extends Vue {
  
}
</script>


// WEBPACK FOOTER //
// src/components/Loader.vue